export enum Position {
  BEFORE = 'before',
  AFTER = 'after',
}
